import {nextTick} from 'vue'

export const focusElementById = async (id: string) => {
  if (typeof document === 'undefined') {
    return
  }

  await nextTick()

  const focusElement = () => {
    const element = document.getElementById(id)

    if (element && typeof element.focus === 'function') {
      element.focus()
    }
  }

  if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
    window.requestAnimationFrame(() => {
      focusElement()
    })
    return
  }

  focusElement()
}
